import { gql } from '@apollo/client';

export const insertLocationMutation = gql`
  mutation ($object: locations_insert_input!) {
    insert_locations_one(object: $object) {
      id
    }
  }
`;

export interface InsertLocationResponse {
  insert_locations_one: {
    id: string;
  };
}
